/* eslint-disable perfectionist/sort-objects */

const TENANT = "/portal/[^/]+";

const orderPageMapping: { [key: string]: PageMapping } = {
	[`${TENANT}/orders/.+`]: {
		nav: false,
		title: "",
		description: "",
		label: "Order",
		labelKey: "nav.portal.order.label",
		buttons: [],
		actions: [],
		identifier: true
	}
};

export const featurePageMapping: { [key: string]: PageMapping } = {
	[TENANT]: {
		nav: false,
		title: "",
		label: "Portal",
		labelKey: "nav.portal.module.label",
		icon: "home",
		buttons: [],
		actions: []
	},
	[`${TENANT}/dashboard`]: {
		nav: true,
		title: "Dashboard",
		titleKey: "nav.portal.dashboard.title",
		description: "",
		label: "Dashboard",
		labelKey: "nav.portal.dashboard.label",
		icon: "dashboard",
		buttons: [],
		actions: []
	},
	[`${TENANT}/catalog`]: {
		nav: true,
		title: "Catalog",
		titleKey: "nav.portal.catalog.title",
		description: "",
		label: "Catalog",
		labelKey: "nav.portal.catalog.label",
		icon: "local_florist",
		buttons: [],
		actions: []
	},
	[`${TENANT}/import`]: {
		nav: false,
		title: "Import Catalog Order",
		titleKey: "nav.portal.import.title",
		description: "",
		label: "Import",
		labelKey: "nav.portal.import.label",
		buttons: [],
		actions: []
	},
	[`${TENANT}/cart`]: {
		nav: true,
		title: "Shopping Cart",
		titleKey: "nav.portal.cart.title",
		description: "",
		label: "Cart",
		labelKey: "nav.portal.cart.label",
		icon: "shopping_cart",
		buttons: [],
		actions: []
	},
	[`${TENANT}/orders`]: {
		nav: true,
		title: "Order History",
		titleKey: "nav.portal.orders.title",
		description: "",
		label: "Orders",
		labelKey: "nav.portal.orders.label",
		icon: "receipt_long",
		buttons: [],
		actions: []
	},
	[`${TENANT}/account`]: {
		nav: true,
		title: "Account",
		titleKey: "nav.portal.account.title",
		description: "",
		label: "Account",
		labelKey: "nav.portal.account.label",
		icon: "account_circle",
		buttons: [],
		actions: []
	}
};

export const flatPageMapping: { [key: string]: PageMapping } = {
	...featurePageMapping,
	...orderPageMapping
};
